/** Normalize for comparison: lowercase, trim, treat underscores as spaces */
function normalizeEmploymentType(s) {
  if (s == null || s === "") return "";
  return String(s).toLowerCase().trim().replace(/_/g, " ");
}

/**
 * Resolves whether an employment type value represents an unemployed person
 * using the SETA configuration employmentTypes array (each item: { label, value, isUnemployedType }).
 * Matching normalizes underscores and spaces so e.g. "unemployed_learner" matches "Unemployed Learner".
 * @param {Array<{ label?: string, value?: string, isUnemployedType?: boolean }>|undefined} employmentTypes - from file_structure.sheets[0].employmentTypes or field.allowedValues
 * @param {string|null|undefined} employmentTypeValue - form value (e.g. "unemployed_learner" or "Student")
 * @returns {boolean} true if this employment type is marked as unemployed in config
 */
export function isUnemployedEmploymentType(employmentTypes, employmentTypeValue) {
  if (employmentTypeValue == null || employmentTypeValue === "") return false;
  if (!employmentTypes || !Array.isArray(employmentTypes) || employmentTypes.length === 0) return false;

  const value = normalizeEmploymentType(employmentTypeValue);
  const entry = employmentTypes.find(
    (item) =>
      normalizeEmploymentType(item?.value) === value || normalizeEmploymentType(item?.label) === value
  );
  return Boolean(entry?.isUnemployedType);
}
